import React, { type ReactNode } from 'react'

import { BaseContent, ModalBox, useModalContext } from '@fourthwall/components'

type VideoModalProps = {
  title: string
  description: string
  video: ReactNode
}

export const VideoModal = ({ title, description, video }: VideoModalProps) => {
  const { close } = useModalContext()

  return (
    <ModalBox title={title} size="large" onClose={close}>
      <BaseContent>{description}</BaseContent>
      <div style={{ marginTop: 24 }}>{video}</div>
    </ModalBox>
  )
}
